<template>
    <div>
        <template
            v-if="showValidationError"
        >
            <v-toolbar
                color="red accent-2"
                class="mb-3 elevation-0"
            >
                <v-icon class="pl-3 pr-3" color="white">warning</v-icon>
                <span
                    style="color: white;"
                    class="font-weight-medium"
                    v-html="validationMessage"
                ></span> <!-- WARNING! THIS CAN BE ARBITRARY! -->
            </v-toolbar>
        </template>
        <template v-else>
            <v-toolbar
                v-if="warningMessage"
                color="yellow darken-2"
                class="mb-3 elevation-0"
            >
                <v-icon
                    class="pl-3 pr-3" color="black"
                >
                    warning
                </v-icon>
                <span
                    style="color: black;"
                    class="font-weight-medium"
                    v-html="warningMessage"
                ></span> <!-- WARNING! THIS CAN BE ARBITRARY! -->
            </v-toolbar>
            <v-card
                v-else-if="processErrorMessage"
                color="red accent-2"
                class="mb-3 elevation-0 pa-4"
                style="min-height:64px;"
            >
                <v-icon
                    class="pl-3 pr-3" color="white"
                >
                    warning
                </v-icon>
                <span
                    style="color: white;"
                    class="font-weight-medium"
                    v-html="processErrorMessage"
                ></span> <!-- WARNING! THIS CAN BE ARBITRARY! -->
            </v-card>
        </template>
    </div>
</template>

<script>

export default {
    name: "InvoiceAlertToolbar",
    components: {
    },
    props: {
        showValidationError: {
            type: Boolean,
            default: false
        },
        validationMessage:{
            type: Boolean,
            deafult: ''
        },
        warningMessage:{
            type: String,
            default: ''
        },
        processErrorMessage: {
            type: String,
            default: ''
        }
    },
    setup() {

        return {
        };
    }
};
</script>
